import React from 'react';

export default ({ logout }) => (
  <button onClick={logout} type="submit" className="lightbox_logout">
    Log out
  </button>
);
